import { omsBaseUrlApi, cpBaseUrl, POST, DELETE, PUT, GET } from '@constants/generic-constants.js';
import NetworkManager from '../../services/network-service.js';
import PermissionsHelper from '../../auth/helper/PermissionHelper.js';
import {
  ACTION_INDEX,
  ACTION_SHOW,
  PERMISSION_KEY_PRODUCT,
  PERMISSION_KEY_WAREHOUSE,
} from '../../constants/permission-constants.js';
import { ACCESS_DENIED } from '../../constants/seller-center-paths.js';
import { redirectToPath } from '../../utils/utils.js';
import { isCP } from '../../utils/app-utils.js';

export const productsListingApi = (params = '') => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_PRODUCT, ACTION_INDEX)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    let url = `${omsBaseUrlApi}/products${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const productOptionListApi = (params = '') => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/option_value_templates${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const productsOptionTypeApi = (params = '') => {
  return new Promise((resolve, reject) => {
    let url = `${isCP() ? cpBaseUrl : omsBaseUrlApi}/option_type_templates${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const addProductsApi = (payload) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/products`;
    NetworkManager.performRequest(url, payload, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateProductsApi = ({ id, body }) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/products/${id}`;
    NetworkManager.performRequest(url, body, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getWarrantyTypesApi = ({ storeId = 1, params = '' }) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/stores/${storeId}/warranty_types${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getReturnTypesApi = ({ storeId = 1, params = '' }) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/stores/${storeId}/return_policies${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getLocationApi = (params = '') => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/locations${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createOptionTypeTemplateApi = (payload = {}) => {
  return new Promise((resolve, reject) => {
    let url = `${isCP() ? cpBaseUrl : omsBaseUrlApi}/option_type_templates`;
    NetworkManager.performRequest(url, payload, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createOptionValueTemplatesApi = (payload = {}) => {
  return new Promise((resolve, reject) => {
    let url = `${isCP() ? cpBaseUrl : omsBaseUrlApi}/option_value_templates/create_option_value_templates`;
    NetworkManager.performRequest(url, payload, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getWarehousesApi = ({ storeId = 1, params = '' }) => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_WAREHOUSE, ACTION_INDEX)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    let url = `${omsBaseUrlApi}/stores/${storeId}/warehouses${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteProductApi = (id = '') => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/products/${id}`;
    NetworkManager.performRequest(url, id, DELETE)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getProductDetailApi = (id) => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_PRODUCT, ACTION_SHOW)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    let url = `${omsBaseUrlApi}/products/${id}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const toggleProductStatusApi = (id) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/products/${id}/change_status`;
    NetworkManager.performRequest(url, id, PUT)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getProductsStats = (body) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/stats/product_stats`;
    NetworkManager.performRequest(url, body, POST)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
